var map = {
	"./assets/thewest-digital-hero-cropped.jpg": 646,
	"./assets/thewest-digital-hero-variation-a-cropped.jpg": 441,
	"./assets/thewest-digital-hero-variation-a.jpg": 647,
	"./assets/thewest-digital-hero-variation-b-cropped.jpg": 648,
	"./assets/thewest-digital-hero-variation-b.jpg": 2523,
	"./assets/thewest-digital-hero-variation-black-friday-cropped.jpg": 649,
	"./assets/thewest-digital-hero-variation-black-friday.jpg": 2524,
	"./assets/thewest-digital-hero-variation-experiment2-cropped.jpg": 650,
	"./assets/thewest-digital-hero-variation-experiment2.jpg": 2525,
	"./assets/thewest-digital-hero-variation-vanishing-cousins-cropped.jpg": 651,
	"./assets/thewest-digital-hero-variation-vanishing-cousins.jpg": 2526,
	"./assets/thewest-digital-hero.jpg": 2527
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2522;